// extracted by mini-css-extract-plugin
export default {"checkboxInCardHeader":"Common_checkboxInCardHeader__mm9gz"};